function HomeIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.3892 1.5525L2.16118 7.25004C1.89143 7.43683 1.73047 7.74406 1.73047 8.07217V18.2133C1.73047 19.2694 2.6134 20.1524 3.66956 20.1524H7.61845C8.17073 20.1524 8.61845 19.7046 8.61845 19.1524V14.491C8.61845 13.9387 9.06616 13.491 9.61844 13.491H13.4348C13.9871 13.491 14.4348 13.9387 14.4348 14.491V19.1524C14.4348 19.7046 14.8825 20.1524 15.4348 20.1524H19.3291C20.3853 20.1524 21.2682 19.2694 21.2682 18.2133V8.07021C21.2682 7.74319 21.1083 7.43683 20.84 7.24983L12.6715 1.55603C11.9861 1.07831 11.076 1.0769 10.3892 1.5525Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default HomeIcon;
